export const webmasterConstants = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT: 'LOGOUT',
  START_LOGOUT: 'START_LOGOUT',

  END_OTHER_SESSIONS: 'END_OTHER_SESSIONS',
  OTHER_SESSIONS_FAILURE: 'OTHER_SESSIONS_FAILURE',

  SET_BALANCE_SUCCESS: 'SET_BALANCE_SUCCESS',
  SET_BALANCE_FAILURE: 'SET_BALANCE_FAILURE',

  SET_NEWS_LIST_SUCCESS: 'SET_WM_NEWS_LIST_SUCCESS',
  SET_NEWS_LIST_FAILURE: 'SET_WM_NEWS_LIST_FAILURE',

  SET_OFFERS_LIST_SUCCESS: 'SET_WM_OFFERS_LIST_SUCCESS',
  SET_OFFERS_LIST_FAILURE: 'SET_WM_OFFERS_LIST_SUCCESS',

  SET_MANAGER_SUCCESS: 'SET_WM_MANAGER_SUCCESS',
  SET_MANAGER_FAILURE: 'SET_WM_MANAGER_FAILURE',

  SET_DYNAMIC_DATA: 'SET_DYNAMIC_DATA',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_FAILURE: 'SET_PASSWORD_FAILURE',

  SET_NOTIFY_SUCCESS: 'SET_NOTIFY_SUCCESS',
  SET_NOTIFY_FAILURE: 'SET_NOTIFY_FAILURE',

  EDIT_NOTIFY_SUCCESS: 'EDIT_NOTIFY_SUCCESS',
  EDIT_NOTIFY_FAILURE: 'EDIT_NOTIFY_FAILURE',

  SET_PAYMENTS_SUCCESS: 'SET_PAYMENTS_SUCCESS',
  SET_PAYMENTS_FAILURE: 'SET_PAYMENTS_FAILURE',

  OFFER_REQUEST_SUCCESS: 'OFFER_REQUEST_SUCCESS',
  OFFER_REQUEST_FAILURE: 'OFFER_REQUEST_FAILURE',

  OFFER_REFUSE_SUCCESS: 'OFFER_REFUSE_SUCCESS',
  OFFER_REFUSE_FAILURE: 'OFFER_REFUSE_FAILURE',

  SET_WALLETS_SUCCESS: 'SET_WALLETS_SUCCESS',
  SET_WALLETS_FAILURE: 'SET_WALLETS_FAILURE',

  ADD_WALLETS_SUCCESS: 'ADD_WALLETS_SUCCESS',
  ADD_WALLETS_FAILURE: 'ADD_WALLETS_FAILURE',

  EDIT_PROFILE_SUCCESS: 'EDIT_PROFILE_SUCCESS',
  EDIT_PROFILE_FAILURE: 'EDIT_PROFILE_FAILURE',

  CONFIRM_PHONE_PROFILE_SUCCESS: 'CONFIRM_PHONE_PROFILE_SUCCESS',
  CONFIRM_PHONE_PROFILE_FAILURE: 'CONFIRM_PHONE_PROFILE_FAILURE',

  SET_DASHBOARD_SETTINGS_SUCCESS: 'SET_DASHBOARD_SETTINGS_SUCCESS',
  SET_DASHBOARD_SETTINGS_FAILURE: 'SET_DASHBOARD_SETTINGS_FAILURE',

  SET_UNREAD_TICKETS_SUCCESS: 'SET_UNREAD_MESSAGES_SUCCESS',
  SET_UNREAD_TICKETS_FAILURE: 'SET_UNREAD_MESSAGES_FAILURE',

  SET_SOCIAL_ACCOUNT_SUCCESS: 'SET_SOCIAL_ACCOUNT_SUCCESS',
  SET_SOCIAL_ACCOUNT_FAILURE: 'SET_SOCIAL_ACCOUNT_FAILURE',

  REMOVE_SOCIAL_ACCOUNT_SUCCESS: 'REMOVE_SOCIAL_ACCOUNT_SUCCESS',
  REMOVE_SOCIAL_ACCOUNT_FAILURE: 'REMOVE_SOCIAL_ACCOUNT_FAILURE',

  DELETE_WALLETS_SUCCESS: 'DELETE_WALLETS_SUCCESS',
  DELETE_WALLETS_FAILURE: 'DELETE_WALLETS_FAILURE',

  SET_BOTS_INFO_SUCCESS: 'SET_BOTS_INFO_SUCCESS',
  SET_BOTS_INFO_FAILURE: 'SET_BOTS_INFO_FAILURE',
  SET_NOVICE_POPUP_AMOUNT_FAILURE: 'SET_NOVICE_POPUP_AMOUNT_FAILURE',
  SET_NOVICE_POPUP_AMOUNT_SUCCESS: 'SET_NOVICE_POPUP_AMOUNT_SUCCESS',
  SET_TOUR_STEP: 'SET_TOUR_STEP',

  SET_TWO_FACTOR_AUTH: 'SET_TWO_FACTOR_AUTH',

  SET_JUST_REGISTERED_HAS_OFFER: 'SET_JUST_REGISTERED_HAS_OFFER',
  SET_JUST_REGISTERED_HAS_STREAM: 'SET_JUST_REGISTERED_HAS_STREAM',
};
